import { Trans } from '@lingui/macro'
import { Alert, AlertTitle, Typography } from '@mui/material'
import { usePendingJoinRequests } from 'app/EgretLayout/Layout1/usePendingJoinRequests'
import { ReduxState } from 'app/redux/ReduxInterfaces'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import React from 'react'
import { useSelector } from 'react-redux'

const typeToConnectPrompLabel = {
  funding: <Trans>FUNDING_NOT_CONNECTED_TO_ORGANIZATION_BANNER_INFO</Trans>,
  sat: <Trans>SAT_NOT_CONNECTED_TO_ORGANIZATION_BANNER_INFO</Trans>
}

const typeToRequestPendingLabel = {
  funding: <Trans>JOIN_REQUEST_PENDING_BANNER_INFO</Trans>,
  sat: <Trans>SAT_JOIN_REQUEST_PENDING_BANNER_INFO</Trans>
}

export const NotConnectedToOrgBanner: React.FC<{ type?: 'funding' | 'sat' }> = ({ type = 'funding' }) => {
  const { pendingJoinRequests } = usePendingJoinRequests()
  const isInternal = sfOauthConfig.isInternal as boolean

  if (pendingJoinRequests == null || isInternal) {
    return null
  }

  return (
    <Alert variant='filled' severity='info'>
      <AlertTitle>
        <Trans>
          NOT_CONNECTED_TO_ORGANIZATION_BANNER
        </Trans>
      </AlertTitle>
      <Typography>
        {pendingJoinRequests.length > 0
          ? typeToRequestPendingLabel[type]
          : typeToConnectPrompLabel[type]}
      </Typography>
    </Alert>
  )
}
